import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import DeleteButton from '../../styled/buttons/DeleteButton'
import { ActionButtonsWrapper, ModalSkillCard } from './_Styled'
import SkillSelect from './SkillSelect'
import SkillSelectMentor from './SkillSelectMentor'
import SliderWrapper from './SliderWrapper'
import MasteryLegend from './MasteryLegend'
import TextFieldsMentor from './TextFieldsMentor'
import TextFieldsStudent from './TextFieldsStudent'
import QuestSubject from '../../mini/QuestSubject'
import { Caption5 } from '../../styled/typography/typography'

const SkillCard = ({
  index,
  isMentor,
  quest,
  onMasteryValueChange,
  onSkillSelect,
  onTrashClick,
  onMentorTextChange,
  onStudentTextChange,
  skillCheck,
  masteryRatingValue,
  selectedSkills,
  numberOfCurrentSkillChecks,
  frameworkSkills,
  frameworkSubjectName,
  focusSkills
}) => {
  const [hovered, setHovered] = useState(false)

  const onDeleteClick = () => {
    onTrashClick(index)
  }

  return (
    <ModalSkillCard
      style={{ zIndex: 1000 - index }}
      onMouseOver={() => {
        setHovered(true)
      }}
      onMouseOut={() => {
        setHovered(false)
      }}
    >
      <div style={{ marginBottom: '8px' }}>
        <QuestSubject
          styleComponent={Caption5}
          textProps={{montserrat: true}}
          subject={frameworkSubjectName}
        />
      </div>
      {isMentor ? (
        <SkillSelectMentor
          index={index}
          onSkillSelect={onSkillSelect}
          skillCheck={skillCheck}
          selectedSkills={selectedSkills}
          quest={quest}
          frameworkSkills={frameworkSkills}
          focusSkills={focusSkills}
        />
      ) : (
        <SkillSelect
          index={index}
          onSkillSelect={onSkillSelect}
          skillId={skillCheck.skillId}
          selectedSkills={selectedSkills}
          quest={quest}
          frameworkSkills={frameworkSkills}
        />
      )}

      <SliderWrapper
        index={index}
        enabled={Boolean(skillCheck.skillId)}
        onMasteryValueChange={onMasteryValueChange}
      />

      <MasteryLegend />

      {masteryRatingValue && (
        <Fragment>
          {isMentor ? (
            <TextFieldsMentor
              index={index}
              onMentorTextChange={onMentorTextChange}
              onStudentTextChange={onStudentTextChange}
            />
          ) : (
            <TextFieldsStudent
              index={index}
              onStudentTextChange={onStudentTextChange}
            />
          )}
        </Fragment>
      )}

      {numberOfCurrentSkillChecks > 1 && (
        <ActionButtonsWrapper visible={hovered}>
          <DeleteButton onClick={onDeleteClick} />
        </ActionButtonsWrapper>
      )}
    </ModalSkillCard>
  )
}

SkillCard.propTypes = {
  dispatch: PropTypes.func,
  index: PropTypes.number,
  isMentor: PropTypes.bool,
  onMasteryValueChange: PropTypes.func,
  onSkillSelect: PropTypes.func,
  onTrashClick: PropTypes.func,
  onMentorTextChange: PropTypes.func,
  onStudentTextChange: PropTypes.func,
  quest: PropTypes.object,
  skillCheck: PropTypes.object,
  selectedSkills: PropTypes.array,
  masteryRatingValue: PropTypes.number,
  numberOfCurrentSkillChecks: PropTypes.number,
  frameworkSkills: PropTypes.array,
  frameworkSubjectName: PropTypes.string,
  focusSkills: PropTypes.array
}

export default SkillCard
